import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import ReplayIcon from '@material-ui/icons/Replay';
import apiClient from "../../../lib/common/apiClient";

function FormItemAutoCode ( props ) {

    const { t } = useTranslation ();
    
    const { column, InputLabelProps, onChange, focusRef, disabled, ...others } = props;

    const [ text, setText ] = useState ("");

    const [ isCreate, setIsCreate ] = useState(true);

    useEffect(() => {

        ( async () => {

            setIsCreate(props.value === "");

            if(props.value === "") {

                const nextAutoCode = await getAutoCode();

                setText(nextAutoCode);

            } else {

                setText(props.value);

            }

        } ) ();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let textFieldProps = {
        InputLabelProps: {
            shrink: true,
            ...InputLabelProps,
        },
        ...others
    };

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            onChange(text)
        }, 50)

        return () =>  clearTimeout(delayDebounceFn) 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text])

    const getAutoCode = async () => {

        return (await apiClient.get ( `api/AutoCode/${column.autoCodeRule}/nextAutoCode` )).data.data;

    }

    const refreshAutoCode = async () => {

        const nextAutoCode = await getAutoCode();

        setText(nextAutoCode);

    }

    if ( column.InputLabelProps ) {

        textFieldProps.InputLabelProps = { ...textFieldProps.InputLabelProps, ...column.InputLabelProps };

    }

    if ( column.placeholder ) {

        textFieldProps.placeholder = t ( column.placeholder );

    }

    if ( column.multiline ) {

        textFieldProps.multiline = true

        if ( column.minRows ) {

            textFieldProps.minRows = column.minRows;

        }

        if ( column.rows ) {

            textFieldProps.rows = column.rows;

        }

        if ( column.rowsMax ) {

            textFieldProps.rowsMax = column.rowsMax;

        }

    }

    if ( column.required ) {

        textFieldProps.required = true;

    }

    if ( column.variant ) {

        textFieldProps.variant = column.variant;

    }

    if ( column.inputProps ) {

        textFieldProps.inputProps = column.inputProps;

    }
    if ( column.password ) {

        textFieldProps.inputProps = { type: "password", ...textFieldProps.inputProps };

    }

    if ( column.InputProps ) {

        textFieldProps.InputProps = column.InputProps;

    }

    if ( column.style ) {

        textFieldProps.style = column.style;

    }

    return (
        <>
            <TextField 
                value={text} 
                inputRef={focusRef} 
                InputProps={{
                    disabled: true,
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={refreshAutoCode} disabled={!isCreate}>
                                <ReplayIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                {...textFieldProps} 
            />
            
        </>
    );

}

export default FormItemAutoCode;
